import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../shared/components/loader';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination'
import moment from 'moment';
import Util from './../../../../shared/util/util'
import TripServices from './../../../services/firstAndLastmilemanagement.service'
import Multiselect from 'vue-multiselect';
import Treeselect from '@riophae/vue-treeselect';
import XLSX from 'xlsx';

export default {
  name: 'UADCutoffs',
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    CustomExpandableTable,
    Pagination,
    Multiselect,
    Treeselect
  },
  data() {
    return {
      tableColumn: ['AWB','UAD Type','Reason','Subreason','Re-Schedule Date','UAD Marked Date','RAD Date', 'Total MPS','Charged Weight','CRM Ticket Raised','Action'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      UADReasonArr: [
        { id: 'operations', label: 'Operation' },
        { id: 'consignee', label: 'Consignee' },
        { id: 'all', label: 'All' }
      ],
      uadsequenceArr: [
        { id: '1', label: '1' },
        { id: '2', label: '2' },
        { id: '3', label: '3' },
        { id: '4', label: '4' },
        { id: '5', label: 'All' },
      ],
      consignorNameArr: [],
      HubsArr: [{hubid: 0, hubname: 'All'}],
      toDate: '',
      AWB: '',
      offset: 0,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      fromDate: '',
      fromerr:'',
      huberr : '',
      selectedHub: '',
      isLoading: false,
      uadreasontype: null,
      Consignorname: null,
      uadsequence:null,
      innerUADList:[],
      UADList:[],
      selectedHub: '',
      toerr : ''
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.userid = parseInt(userdetail.userid);
    // this.userrole = parseInt(userdetail.userrole);
    this.userrole = userdetail.rolename[0];
    this.currentHub = userdetail.hubID[0];
    this.isLoading = true;
    await this.getReport();
    await this.gethubList();
    this.isLoading = false;
    this.getCompanyShortName()
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit;
      this.getReport();
    },
    removedateerr(flag){
      if(flag == 1) {
        this.fromerr = ""
      }
      else {
        this.toerr = ""
      }
    },
    dateChecker(downloadflag = 0){
      let temp
      if(this.fromDate && this.toDate){
        if(this.fromDate>this.toDate){
          this.fromerr = "FromDate should be less than ToDate";
          return true
        } else if (downloadflag ==1 && this.selectedHub.hubid == 0) {
          temp = moment.utc(this.fromDate).add(60,'days').format('YYYY-MM-DD')
          if(this.toDate > temp) {
            this.fromerr = "The difference between FromDate and ToDate needs to be 60 days."
            return true
          }
          else {
            this.fromerr = "";
            return false
          }
        }
        else{
          this.fromerr = "";
          this.toerr = ""
          return false
        }
      }else return false;
    },
    checkerr(){
      if(this.selectedHub.hubid == undefined || this.selectedHub.hubid == null) {
        this.huberr = "Please select Hub"
		this.$alertify.error("Please select hub");
        return true
      }else{
		this.huberr = ""
	  }
      if(!this.toDate && !this.fromDate) {
        this.toerr = "Please Enter ToDate"
        this.fromerr = "Please Enter FromDate"
		this.$alertify.error("Please select RAD From Date and RAD TO Date")
        return true
      }
      else if (!this.toDate) {
        this.toerr = "Please enter toDate"
		this.$alertify.error("Please select RAD TO Date ")
        return true
      }
      else if (!this.fromDate) {
        this.fromerr = "Please enter From date"
		this.$alertify.error("Please select RAD From Date")
        return true
      }
      else {
		this.toerr = ""
		this.fromerr = ""
        return false
      }
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.consignorNameArr.push({
            'id': CompanyShortList[i].CompanyName,
            'label': CompanyShortList[i].ClientShortName,
            // 'CompanyName': CompanyShortList[i].CompanyName
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async gethubList() {
      try {
        this.isLoading = true;
        let fetchHub = await TripServices.GetHublist();
        if (fetchHub.data.code === 200) {
          let data = fetchHub.data.data.data;
          for (var i = 0; i < data.length; i++) {
            if(data[i].HubID == this.currentHub){
              this.selectedHub = {
                hubid: data[i].HubID,
                hubname: data[i].HubName
              }
            }
            this.HubsArr.push({
              hubid: data[i].HubID,
              hubname: data[i].HubName
            })
          }
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
clearForm(){
  this.selectedHub = ''
  this.currentPage = 1;
  this.offset = 0;
  this.uadreasontype = null;
  this.Consignorname = null;
  this.uadsequence = null;
  this.toDate=''
  this.fromDate=''
  this.AWB=''
  this.fromerr = "";
  this.huberr = "";
  this.toerr = "";
  this.getReport();
},
getCustomTableEvent(){},
selectHub(e){
  this.selectedHub = e;
},
searchShipment(){
  this.currentPage = 1;
  this.offset = 0;
  if(this.dateChecker(0)) return;
  this.getReport();
},
async getReport(){
try {
  this.isLoading = true;
  let inputPayload = {
    "offset": this.offset,
    "limit": this.pageLimit,
    "hubid":this.currentHub
  }
  if(this.selectedHub){
    inputPayload.hubid = this.selectedHub.hubid
  }
  if(this.fromDate){
    inputPayload.fromdate = moment(this.fromDate).format('YYYY-MM-DD')
  }
  if(this.toDate){
    inputPayload.todate =  moment(this.toDate).format('YYYY-MM-DD')
  }
  if(this.AWB){
    inputPayload.awb = this.AWB
  }
  if(this.Consignorname){
      inputPayload.clientname = this.Consignorname.id
  }
  if(this.uadsequence && this.uadsequence!='5'){
    inputPayload.uadsequence = this.uadsequence
  }
  if(this.uadreasontype && this.uadreasontype!='all'){
    inputPayload.uadreason = this.uadreasontype
  }
  let result = await TripServices.GetUADReport(inputPayload);
  if(result.data.code == 200){
    this.totalCount = Number(result.data.data.count);
    if(this.totalCount > 0){
      this.innerUADList = result.data.data.rows;
      this.tableItems = result.data.data.rows.map((item,index)=>{
        let obj = {
         'id':item.id,
         'AWB' : item.awb,
         'UAD Type' : item.uadtype == 'consignee'?'Consignee':'Operation',
         'Reason':item.reason,
         'Subreason':item.subreason,
         'Total MPS' : item.totalmps,
         'Re-Schedule Date': item.rescheduledate == null ? null :Util.displayDateOnlyFormat(item.rescheduledate),
         'UAD Marked Date':item.createddate,
         'RAD Date': item.raddate,
         'CRM Ticket Raised' : item.raisetickedid == null ? 'No' : 'Yes',
         'Charged Weight' : item.chargedweight,
         'Action' : "Event Onclick"
       }
       return obj;
       })


    }else{
    this.tableItems = [];
    this.innerUADList = [];
    }
  }else{
    this.totalCount = 0
    this.innerUADList = [];
    this.tableItems = [];
  }
  if (this.totalCount < this.pageLimit) {
    this.totalPage = 1
  } else {
    this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
  }
  this.isLoading = false;
} catch (error) {
  console.log(error)
  this.isLoading = false;
}
},

async Downloaduadreport(){
  try {
    if(this.checkerr()){
      return false
    };
    if(this.dateChecker(1)) return;
    this.isLoading = true;
    let inputPayload = {
      "hubid" : this.currentHub
    }
    if(this.selectedHub){
      inputPayload.hubid = this.selectedHub.hubid
    }
    if(this.fromDate){
      inputPayload.fromdate = moment(this.fromDate).format('YYYY-MM-DD')
    }
    if(this.toDate){
      inputPayload.todate =  moment(this.toDate).format('YYYY-MM-DD')
    }
    if(this.AWB){
      inputPayload.awb = this.AWB
    }
    if(this.Consignorname){
        inputPayload.clientname = this.Consignorname
    }
    if(this.uadsequence && this.uadsequence!='5'){
      inputPayload.uadsequence = this.uadsequence
    }
    if(this.uadreasontype && this.uadreasontype!='all'){
      inputPayload.uadreason = this.uadreasontype
    }
    let result = await TripServices.GetUADReport(inputPayload);
    if(result.data.code == 200){
      this.totalCount = Number(result.data.data.count);
      if(this.totalCount > 0){
        this.innerUADList = result.data.data.rows;
        let reportdata = result.data.data.rows.map((item,index)=>{
          return {
           'AWB' : item.awb,
           'UAD Type' : item.uadtype == 'consignee'?'Consignee':'Operation',
           'Reason':item.reason,
           'Subreason':item.subreason,
           'Total MPS' : item.totalmps,
           'Re-Schedule Date': item.rescheduledate == null ? null :Util.displayDateOnlyFormat(item.rescheduledate),
           'UAD Marked Date':item.createddate,
           'RAD Date': item.raddate,
           'CRM Ticket Raised' : item.raisetickedid == null ? 'No' : 'Yes',
           'Charged Weight' : item.chargedweight,
           'Consignor Name' : item.clientname,
           'UAD Marked By' : item.createdby,
           'UAD Sequence' : item.uadmarkedsequence,
           'RAD Cut Off' : item.radcutoff,
           'UAD Cut Off' : item.uadcutoff,
           'Origin Hub Code' : `${item.originhubname}(${item.originhubid})`,
           'Destination Hub Code' : `${item.destinationhubname}(${item.destinationhubid})`,
           'Destinaiton Hub Name' : item.destinationhubname
         }
        //  return obj;
         })
         let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
         const data = XLSX.utils.json_to_sheet(reportdata);
         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, data, 'data')
         XLSX.writeFile(wb,dt+'uadreport.xlsx');

      }else{
      this.tableItems = [];
      this.innerUADList = [];
      }
    }else{
      this.totalCount = 0
      this.innerUADList = [];
      this.tableItems = [];
    }
    this.isLoading = false;
  } catch (error) {
    console.log(error)
    this.isLoading = false;
  }
  },

async getCustomTableEvent(event){
   if(event.actionType=="view"){
    let viewUADRepoList  = this.innerUADList.filter(function(Items) {
      return Items.id == event.id;
    });
    this.UADList = viewUADRepoList;
  }
},
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/configuration/UADReport/UADReport.component.js